module.exports = __webpack_public_path__ + "img/official_qrcode.bec0c8c.jpg";